module.exports = __webpack_public_path__ + "img/92.291febf2.jpg";